import { writable, derived, get } from 'svelte/store';
import { generateQuiz, getPercentage } from '../components/utils';

// Settings
export const numberOfQuestions = writable(20);
const SIMULATION_QUESTIONS_COUNT = 20;

// App State
export const hasQuizBegun = writable(false);
export const isSimulationMode = writable(false);
export const currentQuestionIndex = writable(0);
export const isQuizDone = writable(false);

// Data
export const triviaCategories = writable([]);
export const maxNumberOfQuestions = derived(triviaCategories, $triviaCategories => {
    return $triviaCategories.flat().length
}, 0)

export const quiz = derived([hasQuizBegun, isSimulationMode, triviaCategories], ([$hasQuizBegun, $isSimulationMode, $triviaCategories], set) => {
    if ($hasQuizBegun) {
        let questions;
        if($isSimulationMode) {
            questions = $triviaCategories.flatMap(it => generateQuiz(it, SIMULATION_QUESTIONS_COUNT));
            numberOfQuestions.set(questions.length);
        }
        else questions = generateQuiz($triviaCategories.flat(), get(numberOfQuestions));
        set(questions);
    }
}, [])

export const schoolScore = writable(32.1);
export const score = writable(0);
export const scorePercentage = derived([score, quiz], ([$score, $quiz]) => {
    return getPercentage($score, $quiz.length);
}, 0);
export const detailedScore = writable([]);
export const reset = () => {
    score.set(0);
    hasQuizBegun.set(false);
    currentQuestionIndex.set(0);
    isQuizDone.set(false);
    detailedScore.set([]);
}


